import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class ComprobantesToolbarActions extends Component {
  state = {
    busy: false,
    isOpen: false,
  };

  constructor(props) {
    super(props);

    const { data = {} } = props;

    this.state.data = {
      status: data.status || '',
      clasificacion: data.clasificacion || '',
    };
  }

  handleOnToggleSelectableItems = () => {
    this.props.onToggleSelectableItems();
  };

  goToComprobanteCreatePage = () => {
    this.props.history.push('/app/comprobantes/timbrado');
  };

  goToComprobanteColumnConfig = () => {
    this.props.history.push('/app/comprobantes/config');
  };

  goToTimbradoMasivoPage = () => {
    this.props.history.push('/app/timbrado-masivo');
  };

  filterByClassification = (clasificacion) => {
    this.setState({
      data: {
        ...this.state.data,
        clasificacion,
      },
    });
  };

  filterByStatus = (status) => {
    this.setState({
      data: {
        ...this.state.data,
        status,
      },
    });
  };

  download = async () => {
    const params = {
      ...this.props.data,
      as: 'link',
      download: 1,
    };

    this.setState({
      busy: true,
    });

    try {
      const response = await Http.get(`${window.BONJOUR_URL}/api/comprobantes`, { params });

      if (!!response.data && !!response.data.link) {
        window.location = response.data.link;
      } else {
        window.ToastManager.show({
          variant: 'error',
          title: 'Sesión',
          message: 'Error al descargar tu reporte',
        });
      }

      this.setState({
        busy: false,
      });
    } catch (error) {
      this.setState({
        busy: false,
      });

      window.ToastManager.show({
        variant: 'error',
        title: 'Sesión',
        message: (!!error.data && error.data.message) || 'No se pudo procesar tu solicitud',
      });
    }
  };

  componentWillUnmount() {
    this.setState = () => {};
  }

  renderDownloading = () => {
    const { busy } = this.state;

    return (
      <LoadingButton
        type="button"
        variant="transparent"
        loading={busy}
      >
        Descargando
      </LoadingButton>
    );
  };

  onToggleHandler = (isOpen, e, metadata) => {
    if (metadata.source === 'rootClose') {
      const isClassificationChange =
        !!this.state.data.clasificacion && this.state.data.clasificacion !== this.props.clasificacion;
      const isStatusChange = !!this.state.data.status && this.state.data.status !== this.props.status;

      if (isClassificationChange || isStatusChange) {
        this.props.onFilterChange(this.state.data);
      }
    }

    if (metadata.source !== 'select') {
      this.setState({
        isOpen,
      });
    }
  };

  applyFilters = () => {
    this.onToggleHandler(false, {}, { source: 'rootClose' });
  };

  render() {
    if (this.state.busy) {
      return this.renderDownloading();
    }

    return (
      <ButtonToolbar
        aria-label="Acciones"
        className="d-inline-flex dropdown-without-icon"
      >
        {Guardian.allows('facturas.create') && Guardian.allows('factura.crear') && (
          <ButtonGroup
            className="mr-2"
            aria-label="Nueva factura"
          >
            <Button
              variant="primary"
              onClick={this.goToComprobanteCreatePage}
            >
              <FontAwesomeIcon icon={['fas', 'plus']} /> Factura
            </Button>
          </ButtonGroup>
        )}
        <ButtonGroup aria-label="Acciones secundarias">
          <Button
            variant="secondary"
            onClick={this.handleOnToggleSelectableItems}
          >
            <FontAwesomeIcon icon={['fas', 'check']} />
          </Button>
          {Guardian.allows('factura.descarga.masiva.csv') && (
            <Button
              variant="secondary"
              onClick={this.download}
            >
              <FontAwesomeIcon icon={['fas', 'download']} />
            </Button>
          )}
        </ButtonGroup>
      </ButtonToolbar>
    );
  }
}

export default withRouter(ComprobantesToolbarActions);
